// extracted by mini-css-extract-plugin
export default {"containerr":"_2hQdN","mobile":"_2AiWV","loader":"_3yUSP","button":"_20YbL","loading":"_1tbTx","full":"_2rNsG","rounded":"RfyW1"};